import { render } from "./Loading.vue?vue&type=template&id=4fa8506c"
const script = {}
script.render = render

export default script